export default "__VITE_ASSET__$sqcKSG3__"